/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2023-10-24 14:39:27
 * @LastEditors: xiawenlong
 * @LastEditTime: 2024-03-19 17:59:35
 */
export default [
  {
    path: '/kyga',
    name: 'Kyga',
    component: () => import(/*webpackChunkName:'Kyga'*/ '@/views/special/kyga'),
    meta: { title: '中潮教育明职道抗疫关爱行动' },
  },
  {
    path: '/bankLivePlay',
    name: 'Hbba',
    component: () => import(/*webpackChunkName:'Hbba'*/ '@/views/special/hbba'),
    meta: { title: '湖北省银行业协会' },
  },
  {
    path: '/leader',
    name: 'leader',
    component: resolve => require(['@/views/special/leader'], resolve),
    meta: { title: '武汉市科技型民营企业领军人才“头雁”训练营（第一期）' },
  },
]
